import React, { Fragment, useState } from "react"
import Row from "react-bootstrap/lib/Row"
import Col from "react-bootstrap/lib/Col"
import Button from "react-bootstrap/lib/Button"

import ForgotPasswordLink from "../ForgotPasswordLink"
import EmailInput from "../../../../ui-components/EmailInput"
import PasswordInput from "../../../../ui-components/PasswordInput"
import SubmitButton from "../../../../ui-components/SubmitButton"
import { CreateUserSession } from "../../../../apis/UserSessionAPI"
import AlertModal from "../../../../ui-components/AlertModal"

import style from "./index.module.sass"
import SignupOrSeparator from "../../SignupOrSeparator"

import FR_LOGO from "../../../../../../assets/images/logo_shield.svg"

function EmailSignInForm(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { onLogin } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  const [provider, setProvider] = useState(null)

  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [errorModalText, setErrorModalText] = useState("")

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function handleEmailChanged(event) {
    setEmail(event.target.value)
  }

  function handlePasswordChanged(event) {
    setPassword(event.target.value)
  }

  function handleSubmit(event) {
    event.preventDefault()

    CreateUserSession(email, password)
      .then((res) => {
        if (onLogin) {
          onLogin(res)
        }
      })
      .catch((error, response) => {
        setErrorModalText(I18n.t("pages.user_session.user.bad_data"))
      })
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------
  return (
    <div>
      <AlertModal
        title={I18n.t("pages.user_session.user.warning")}
        text={errorModalText}
        show={!!errorModalText}
        onClose={() => setErrorModalText(null)}
      />

      {!provider && (
        <Fragment>
          <Row>
            <Col sm={12}>
              <Button
                className={[style.button, style.frButton]}
                onClick={() => setProvider("FR")}
              >
                <img className={style.frIcon} src={FR_LOGO} />
                {I18n.t("pages.user_session.sign_in.sign_in_foodracers")}
              </Button>
            </Col>
          </Row>

          <SignupOrSeparator />

          <Row>
            <Col sm={12}>
              <Button
                className={style.button}
                bsStyle="primary"
                onClick={() => setProvider("TLT")}
              >
                {I18n.t("pages.user_session.sign_in.sign_in_email")}
              </Button>
            </Col>
          </Row>
        </Fragment>
      )}

      {provider && (
        <Fragment>
          <Row className="mt-5">
            <Col sm={12} className={style.center}>
              <a
                className={style.change}
                onClick={() => {
                  setProvider(null)
                }}
              >
                {I18n.t("pages.user_session.sign_in.change_method")}
              </a>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col sm={12}>
              {I18n.t("pages.user_session.sign_in.sign_in_email_and_password")}
            </Col>
          </Row>

          <form onSubmit={handleSubmit} className="mt-3">
            <Row>
              <Col sm={12}>
                <EmailInput
                  name="user_email"
                  value={email}
                  placeholder={I18n.t(
                    "pages.user_session.user.not_required_email"
                  )}
                  onChange={handleEmailChanged}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <PasswordInput
                  name="user_password"
                  value={password}
                  placeholder={I18n.t(
                    "pages.user_session.user.not_required_password"
                  )}
                  onChange={handlePasswordChanged}
                />
                <ForgotPasswordLink />
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <SubmitButton
                  className="sign-user-page-btn btn-blue"
                  value={I18n.t("sign_in")}
                />
              </Col>
            </Row>
          </form>
        </Fragment>
      )}
    </div>
  )
}

export default EmailSignInForm
